module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.e55a20c.woff";